import cnBind from "classnames/bind";
import Link from "next/link";
import type { UrlObject } from "url";
import type { GetCategoryDto } from "@/entities/types/entities";
import { API_BASE } from "@/shared/constants/private";
import { CustomImage } from "@/shared/ui/CustomImage";
import styles from "./Card.module.scss";

const cx = cnBind.bind(styles);

type Props = {
    data: GetCategoryDto;
    href: string | UrlObject;
    as?: string;
    className?: string;
};

export const Card = ({ data, href, as, className }: Props) => {
    const { title, description, previewPictureId } = data;

    return (
        <Link href={href} as={as} className={cx("card", className)}>
            <div className={cx("image-wrapper")}>
                <CustomImage
                    className={cx("image")}
                    fill
                    src={`${API_BASE}/picture/${previewPictureId}`}
                    alt={title || "poster"}
                    sizes="382px"
                    fetchPriority={"auto"}
                />
            </div>
            <div className={cx("text")}>
                <h2>{title}</h2>
                {description && <p>{description}</p>}
            </div>
        </Link>
    );
};
